import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  itemBox: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 8,
    padding: 8,
    background: theme.background.b2,
    borderRadius: theme.borderRadius.md,
  },

  tooltipIcon: {
    fontSize: 16,
    color: theme.secondary.s3,
    marginLeft: 8,
  },
  value: {
    ...dFlex(),
    width: '100%',
  },
}));

export default useStyles;
